<div style="background-color: bisque;">
    <app-grid [columns]="columns" 
            [settings]="settings"
            [rows]="rows"
            [parentControlledFields]="parentControlledFields"
            (eventEmission)="onEventEmission($event)">
    </app-grid>
</div>